// Mock data describing the OpenMon project
export const GAME_URL = "https://mickaelvanhoutte.github.io/openmon/";

// $POKEREALMS token
export const TOKEN_TICKER = "$POKEREALMS";
export const CONTRACT_ADDRESS = "He3ogSb1LoJzfNBjbqwHnUieLhiLFV76riMkpkkapump";

export const features = [
  {
    title: "2.5D Overworld",
    desc: "3D tile-based world with billboard sprites, dynamic camera, and weather particles.",
    icon: "Map",
  },
  {
    title: "Turn-based Battles",
    desc: "Type effectiveness, 150+ abilities, held items, status conditions, weather & terrain.",
    icon: "Swords",
  },
  {
    title: "600+ Species",
    desc: "Massive Pokédex with viewed/caught tracking across hundreds of creatures.",
    icon: "BookOpen",
  },
  {
    title: "Dungeon Mode",
    desc: "Procedurally generated floors, biome encounters, boss battles & meta progression.",
    icon: "Castle",
  },
  {
    title: "PC Storage",
    desc: "Box system with drag-and-drop management for your entire collection.",
    icon: "Boxes",
  },
  {
    title: "Quest Engine",
    desc: "NPC dialogues, quests with objectives, and map-triggered scripted events.",
    icon: "ScrollText",
  },
  {
    title: "Evolution & EVs",
    desc: "Leveling, natures, IVs/EVs and full evolution chains, just like the originals.",
    icon: "Sparkles",
  },
  {
    title: "Follower Mon",
    desc: "A creature from your party follows you around the overworld at all times.",
    icon: "Footprints",
  },
  {
    title: "Offline PWA",
    desc: "Installable as a Progressive Web App. Multiple save slots in localStorage.",
    icon: "Download",
  },
];

export const techStack = [
  { name: "Svelte 5", category: "Framework" },
  { name: "TypeScript", category: "Language" },
  { name: "Vite 7", category: "Build" },
  { name: "Three.js", category: "3D" },
  { name: "Threlte", category: "3D" },
  { name: "GSAP", category: "Animation" },
  { name: "Howler.js", category: "Audio" },
  { name: "SCSS", category: "Style" },
  { name: "Vitest", category: "Tests" },
  { name: "Playwright", category: "E2E" },
];

export const stats = [
  { label: "Species", value: "600+" },
  { label: "Abilities", value: "150+" },
  { label: "Items", value: "200+" },
  { label: "UI Components", value: "70+" },
];

export const screenshots = [
  { title: "Overworld", desc: "Explore a 2.5D world rendered with Three.js" },
  { title: "Battle", desc: "Classic turn-based combat with full mechanics" },
  { title: "Pokédex", desc: "Track every creature you discover and catch" },
  { title: "Dungeons", desc: "Procedural floors with seeded RNG and bosses" },
];
